function normalizeCatalogValue(value) {
  return String(value ?? "").trim().toLowerCase();
}

function searchableCatalogValue(value) {
  return String(value ?? "")
    .trim()
    .replace(/\b0\b/g, " ")
    .replace(/\s+/g, " ");
}

function formatFitmentSearchLabel(product) {
  const parts = [String(product.fitmentMake ?? "").trim(), String(product.fitmentModel ?? "").trim()].filter(Boolean);
  const yearFrom = Number(product.fitmentYearFrom);
  const yearTo = Number(product.fitmentYearTo);
  const hasYearFrom = Number.isInteger(yearFrom) && yearFrom >= 1900;
  const hasYearTo = Number.isInteger(yearTo) && yearTo >= 1900;
  const engine = String(product.fitmentEngine ?? "").trim();

  if (hasYearFrom || hasYearTo) {
    parts.push(
      hasYearFrom && hasYearTo && yearFrom !== yearTo
        ? `${yearFrom}-${yearTo}`
        : String(hasYearFrom ? yearFrom : yearTo)
    );
  }

  if (engine) {
    parts.push(engine);
  }

  return parts.join(" ");
}

function uniqueSorted(values) {
  return Array.from(new Set(values)).sort((first, second) => first.localeCompare(second));
}

export function productSearchText(product) {
  return [
    product.name,
    product.sku,
    product.brand,
    product.category,
    product.condition,
    searchableCatalogValue(product.description),
    searchableCatalogValue(product.fitment),
    searchableCatalogValue(product.fitmentMake),
    searchableCatalogValue(product.fitmentModel),
    searchableCatalogValue(product.fitmentEngine),
    searchableCatalogValue(product.fitmentNotes),
    formatFitmentSearchLabel(product),
    "Kenya",
  ]
    .join(" ")
    .toLowerCase();
}

export function buildCatalogFilterOptions(products) {
  const brands = [];
  const conditions = [];
  const engines = [];
  const makes = [];
  const models = [];
  const years = [];

  for (const product of products) {
    const brand = String(product.brand ?? "").trim();
    const condition = String(product.condition ?? "").trim();
    const make = String(product.fitmentMake ?? "").trim();
    const model = String(product.fitmentModel ?? "").trim();
    const engine = String(product.fitmentEngine ?? "").trim();
    const yearFrom = Number(product.fitmentYearFrom);
    const yearTo = Number(product.fitmentYearTo);

    if (brand) brands.push(brand);
    if (condition) conditions.push(condition);
    if (make) makes.push(make);
    if (model) models.push(model);
    if (engine) engines.push(engine);

    if (Number.isInteger(yearFrom) && Number.isInteger(yearTo) && yearTo >= yearFrom) {
      for (let year = yearFrom; year <= yearTo; year += 1) {
        years.push(String(year));
      }
    } else if (Number.isInteger(yearFrom)) {
      years.push(String(yearFrom));
    } else if (Number.isInteger(yearTo)) {
      years.push(String(yearTo));
    }
  }

  return {
    brands: uniqueSorted(brands),
    conditions: uniqueSorted(conditions),
    engines: uniqueSorted(engines),
    makes: uniqueSorted(makes),
    models: uniqueSorted(models),
    years: uniqueSorted(years),
  };
}

export function matchesCatalogFilters(product, filters) {
  const normalizedFilters = {
    brand: normalizeCatalogValue(filters.brand),
    condition: normalizeCatalogValue(filters.condition),
    engine: normalizeCatalogValue(filters.engine),
    make: normalizeCatalogValue(filters.make),
    model: normalizeCatalogValue(filters.model),
    year: normalizeCatalogValue(filters.year),
  };

  if (normalizedFilters.brand && normalizeCatalogValue(product.brand) !== normalizedFilters.brand) {
    return false;
  }

  if (normalizedFilters.condition && normalizeCatalogValue(product.condition) !== normalizedFilters.condition) {
    return false;
  }

  if (normalizedFilters.engine && normalizeCatalogValue(product.fitmentEngine) !== normalizedFilters.engine) {
    return false;
  }

  if (normalizedFilters.make && normalizeCatalogValue(product.fitmentMake) !== normalizedFilters.make) {
    return false;
  }

  if (normalizedFilters.model && normalizeCatalogValue(product.fitmentModel) !== normalizedFilters.model) {
    return false;
  }

  if (normalizedFilters.year) {
    const selectedYear = Number(normalizedFilters.year);
    const yearFrom = Number(product.fitmentYearFrom);
    const yearTo = Number(product.fitmentYearTo);

    if (!Number.isInteger(selectedYear)) {
      return false;
    }

    if (!Number.isInteger(yearFrom) && !Number.isInteger(yearTo)) {
      return false;
    }

    const lowerBound = Number.isInteger(yearFrom) ? yearFrom : yearTo;
    const upperBound = Number.isInteger(yearTo) ? yearTo : yearFrom;

    if (selectedYear < lowerBound || selectedYear > upperBound) {
      return false;
    }
  }

  return true;
}

export function matchesProductQuery(product, query) {
  const normalizedQuery = String(query ?? "").trim().toLowerCase();

  if (!normalizedQuery) {
    return true;
  }

  return productSearchText(product).includes(normalizedQuery);
}
